@if (showIcon()) {
    <div
        id="cs-fav-icon"
        class="icon-container theme-favorite-i-non-touch"
        data-decoratorclass-host
        [class.theme-favorite-i]="variant() === favVariants.Filled && iconKind() === favIconKinds.Star"
        [class.theme-favorite]="variant() === favVariants.Hollow && iconKind() === favIconKinds.Star"
        [class.theme-heart-outline]="variant() === favVariants.Hollow && iconKind() === favIconKinds.Heart"
        [class.theme-heart-solid]="variant() === favVariants.Filled && iconKind() === favIconKinds.Heart"></div>
}
